/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBED EDITOR : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	embededitor: {
        position: 'relative',
		marginBottom: pxToEm(20),
        '&.greyOut':{
            pointerEvents: 'none',
            filter: 'grayScale(1)',
            opacity: .4
        }
	}
};